export default "__VITE_ASSET__DC7lgtQ2__"